import React from 'react';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Box, ImageListItem, ImageListItemBar } from '@mui/material';
import type { DisplayedFile } from '../../../gallery/filesStore';
import { fileKindService } from 'services/fileService';
import {
  getListItemSx,
  listImageAnimatedActionIconSx,
  listImageBarActionsBottomSx,
  listImageBarSx,
  listImageBarFullTitleSx,
  listImageIconContainerSx,
  listImageVideoContainerSx,
  listImageVideoPreviewSx,
  focusedThumbnailSx,
  selectedThumbnailOutlineSx,
  selectedThumbnailOverlaySx,
} from '../../styles';

interface VideoListItemProps {
  image: DisplayedFile;
  thumbnailSize: number;
  listItemRef: React.RefObject<HTMLLIElement>;
  onClick: (e: React.SyntheticEvent) => void;
  showActions: boolean;
  setShowActions: React.Dispatch<React.SetStateAction<boolean>>;
  actionIcon: React.ReactNode;
  description: string;
  showFullTitle: boolean;
  videoPreviewError: boolean;
  onVideoPreviewError: () => void;
  selected?: boolean;
  focused?: boolean;
}

export const VideoListItem: React.FC<VideoListItemProps> = ({
  image,
  thumbnailSize,
  listItemRef,
  onClick,
  showActions,
  setShowActions,
  actionIcon,
  description,
  showFullTitle,
  videoPreviewError,
  onVideoPreviewError,
  selected = false,
  focused = false,
}) => {
  const videoSource = fileKindService.resolveVideoPreviewSource(image);
  const videoMimeType = fileKindService.resolveVideoMimeType(image);
  const resolvedActionIcon = showFullTitle ? (
    <Box sx={listImageAnimatedActionIconSx(showActions)}>{actionIcon}</Box>
  ) : showActions ? (
    actionIcon
  ) : undefined;

  return (
    <ImageListItem
      ref={listItemRef}
      sx={[getListItemSx(thumbnailSize, true), selected && selectedThumbnailOutlineSx, focused && focusedThumbnailSx]}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      {selected && <Box sx={selectedThumbnailOverlaySx} />}
      {videoSource && !videoPreviewError ? (
        <Box onClick={onClick} sx={listImageVideoContainerSx}>
          <video
            key={videoSource}
            crossOrigin='use-credentials'
            preload='metadata'
            muted
            playsInline
            style={listImageVideoPreviewSx}
            onError={onVideoPreviewError}
          >
            <source src={videoSource} type={videoMimeType} />
          </video>
        </Box>
      ) : (
        <Box onClick={onClick} sx={listImageIconContainerSx}>
          <VideocamIcon />
        </Box>
      )}
      <ImageListItemBar
        title={description}
        actionIcon={resolvedActionIcon}
        onClick={onClick}
        sx={
          showFullTitle
            ? [listImageBarSx, listImageBarFullTitleSx, listImageBarActionsBottomSx]
            : listImageBarSx
        }
      />
    </ImageListItem>
  );
};
